import styled from 'styled-components';

const DifficultyIcon = styled.img`
  width: 25px;
  margin: 0 1rem 0 2rem;
`;

export default DifficultyIcon;
